<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <div class="has-error" v-if="data.useForm.validateInfos[itemsKey]?.validateStatus === 'error'">
        <div class="ant-form-explain">
            {{ data.useForm.validateInfos[itemsKey]?.help }}
        </div>
    </div>
    </Card>
</template>

<script>
import { Card, Form } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../app.logic";
import { initForm } from "./attachment.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        dataProp: {},
        dataKey: {},
        isLoading: {}
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        return {
            props,
            data,
            refs
        };
    }
});
</script>
